import request from "@/utils/request";
var activity = '/activity'
//获取一元购规则
export function getPurchaseRules() {
    return request({
        method: 'get',
        url: activity + '/v3/public/mall/prize/service'
    })
}
//走马灯信息
export function getHorseLamp(data) {
    return request({
        method: 'get',
        url: activity + '/v3/public/mall/prize/msg/list',
        data
    })
}

//数据列表
export function getShopData(data) {
    return request({
        method: 'get',
        url: activity + '/v3/public/mall/prize/list',
        data
    })
}
//获取商品详情信息
export function getShopDetail(id) {
    return request({
        method: 'get',
        url: activity + `/v3/public/mall/prize/${id}`
    })
}
//获取用户资产
export function getUserAssets(data) {
    return request({
        method: 'get',
        url: activity + '/v3/mall/order/asset',
        data
    })
}
//获取参与商品的列表
export function getShopStore(data) {
    // console.log(data)
    return request({
        method: "get",
        url: activity + '/v3/mall/order/list',
        data
    })
}
//参与商品购买
export function buyPrizeShop(data){
    return request({
        method:'post',
        url:activity+'/v3/mall/order',
        data,
        headers: {'Content-Type': 'application/json; charset=UTF-8'},
    })
}
//查询是否存在待领取
export function askShopStatus(){
    return request({
        method:'get',
        url:activity+'/v3/mall/order/unclaimed',
    })
}
//获取轮播图配置
export function getPurchaseBanner(){
    return request({
        method:'get',
        url:activity+'/v3/public/mall/prize/banners'
    })
}
//轮播图跳转
export function getBannerProduct(productId){
return request({
    method:'get',
    url:activity+`/v3/public/mall/prize/product/${productId}`
})
}
//获取商品的获奖历史记录---走马灯
export function getDetailList(data){
    return request({
        method:'get',
        url:activity + `/v3/public/mall/prize/msg/detail/list`,
        data
    })
}

//获取当前商品的历史获奖信息
export function getPrizeHistory(data){
    return request({
        method:'get',
        url:activity+'/v3/public/mall/prize/winners',
        data
    })
}

//查看已发放记录
export function checkIssuedTakeNotes(data){
return request({
    method:'get',
    url:activity+'/v3/mall/order/getWinnerNew',
    data
})
}

//设置已发放商品为已查看状态
export function ViewedTakeNotes(data){
   return request({
    method:'post',
    url:activity+'/v3/mall/order/setWinnerNewTag',
    data
   })
}


// WEBPACK FOOTER //
// ./src/view/purchase/api/index.js